export { DMS_MODULE } from '../constants';
export const NAME = 'NationalAccount';
export const CRUMB_LABEL_KEY = 'NationalAccount';
export const CRUMB_LABEL_EDIT = 'edtNationalAccount';
export const CRUMB_LABEL_LIST = 'grdNationalAccount';
